import * as React from 'react';
import { IgcToastComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * A toast component is used to show a brief, non-interactive notification.
 *
 * The component integrates with the
 * [Invoker Commands API](https://developer.mozilla.org/en-US/docs/Web/API/Invoker_Commands_API):
 * an Ignite button or a native `<button>` with `command="--show"` / `"--hide"` /
 * `"--toggle"` and `commandfor` pointing to this element will call the
 * corresponding method declaratively without any JavaScript.
 * @slot  - Default slot for the toast content.
 * @csspart base - The base wrapper of the toast.
 * @class
 */
export const IgrToast = /* @__PURE__ */ createComponent({
  tagName: 'igc-toast',
  displayName: 'IgrToast',
  elementClass: Component,
  react: React,
});

export type IgrToast = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrToastModule = Component;
